import {
	NetworkTypeEnum,
	ProvidersMedicalGuide,
} from 'domain/usecases/private/guide-flow/medical-guide/get-providers-v3';
import {IdentifierTelehealthEnum} from '../types';

export const isTelemedicine = (provider: ProvidersMedicalGuide) =>
	provider?.nmBairro === IdentifierTelehealthEnum.DIGITAL_TELECONSULTATION;

export const isSelfNetwork = (provider: ProvidersMedicalGuide) =>
	provider?.tipoRede === NetworkTypeEnum.SELF_NETWORK &&
	provider?.nmBairro !== IdentifierTelehealthEnum.DIGITAL_TELECONSULTATION;

export const isAccreditedNetwork = (provider: ProvidersMedicalGuide) =>
	provider?.tipoRede === NetworkTypeEnum.ACCREDITED_NETWORK;
